var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2483.99 1390.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-6{fill:#ebebff;}.cls-2{opacity:0.3;}.cls-3,.cls-7{fill:#9192ff;}.cls-11,.cls-14,.cls-3{opacity:0.6;}.cls-4{fill:#3335cf;}.cls-14,.cls-5{fill:#fff;}.cls-8{fill:#1b1b43;}.cls-9{fill:#ffa121;}.cls-10{clip-path:url(#clip-path);}.cls-11,.cls-13{fill:#d1d1ff;}.cls-12{fill:#fff2e0;}.cls-15{fill:#c5c5ff;}.cls-16{fill:#ffbc96;}.cls-17{fill:#d28572;}.cls-18{fill:#fe5b52;opacity:0.2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-250 -325.61)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1926.16,871.33a41.89,41.89,0,0,0,41.89,41.89h643A41.88,41.88,0,0,0,2653,871.33v-380H1926.16Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1935.14,1715.66q12.77-7.53,25.27-15.55c106.16-68.2,197.25-168.68,227.34-291.22s-13-266.9-120.76-332.48c-93.73-57-213.72-46.34-319.28-16.47s-207.24,77.09-316.36,88.4c-129.23,13.39-267.8-23.33-385.17,32.39-130.27,61.86-189,230.89-146.78,368.78,19.34,63.21,56.3,118.9,104,164.4Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1124.35,1715.13l-.4-.25c-8.32-5.29-16.56-10.75-24.48-16.24-115.72-80.07-194-188.18-220.45-304.4C847.91,1257.52,897.39,1111,996.66,1046c77.35-50.73,181.72-56.62,310.2-17.49,33.41,10.18,66.94,22.47,99.36,34.37,66.61,24.43,135.48,49.69,206.35,57.58,43.86,4.87,89.58,3.28,133.79,1.73,81.32-2.84,165.4-5.77,239.35,32,121.54,62.14,185.53,235.39,142.64,386.18-18.51,65.1-56.17,116.6-125.92,172.21l-.44.34h-.55Zm28.79-709c-59.81,0-111.56,14.16-154.74,42.48-98.19,64.39-147.1,209.46-116.28,344.93C908.38,1509,986.22,1616.41,1101.28,1696c7.76,5.37,15.83,10.72,24,15.91l875.61-2.21c68.91-55,106.13-106,124.41-170.24,42.5-149.41-20.77-321-141-382.47-73.2-37.43-156.86-34.5-237.78-31.69-44.33,1.55-90.16,3.15-134.26-1.76-71.25-7.92-140.3-33.25-207.08-57.75-32.39-11.88-65.88-24.16-99.2-34.31Q1222.56,1006.12,1153.14,1006.13Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2329,1646.93c-31.3,0-56.77-23.79-56.77-53s25.47-53,56.77-53,56.78,23.79,56.78,53S2360.35,1646.93,2329,1646.93Zm0-86.3c-20.4,0-37,14.92-37,33.27s16.6,33.26,37,33.26,37-14.92,37-33.26S2349.45,1560.63,2329,1560.63Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2059.03 1386.97 1934.79 1386.97 1913.55 1171.4 2080.27 1171.4 2059.03 1386.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2311,1714.71h-128.1l-21.65-219.82h171.4Zm-124.25-4.25h120.4l20.82-211.32h-162Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2037.41 1369.06 1956.4 1369.06 1942.55 1233.92 2051.26 1233.92 2037.41 1369.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M740.18,855.26h-23V851h23a43.24,43.24,0,0,0,15.18-2.73l1.48,4A47.37,47.37,0,0,1,740.18,855.26Zm-46,0h-23V851h23Zm-46,0h-23V851h23Zm-46.05,0H579V851h23Zm-46.06,0H533V851h23Zm-46.05,0h-23V851h23Zm-46.05,0h-23V851h23Zm-46.06,0h-23V851h23Zm-46.05,0h-23V851h23Zm-46.05,0h-23V851h23Zm-46.41-3.67a48,48,0,0,1-19-14.4l3.33-2.64a43.65,43.65,0,0,0,17.31,13.12Zm497.08-13-3.22-2.76a43.47,43.47,0,0,0,9.56-19.49l4.16.85A47.6,47.6,0,0,1,776.38,838.6ZM250.64,815.4a47.48,47.48,0,0,1-.64-7.81V792.06h4.25v15.53a43.56,43.56,0,0,0,.58,7.12Zm537.21-21.59H783.6v-23h4.25ZM254.25,769H250V746h4.25Zm533.6-21.27H783.6v-23h4.25ZM254.25,723H250V700h4.25Zm533.6-21.27H783.6v-23h4.25Zm-533.6-24.78H250v-23h4.25Zm533.6-21.28H783.6v-23h4.25Zm-533.6-24.77H250v-23h4.25Zm533.6-21.28H783.6v-23h4.25Zm-533.6-24.78H250v-23h4.25Zm533.6-21.27H783.6v-23h4.25Zm-533.6-24.78H250v-23h4.25Zm533.6-21.28H783.6v-23h4.25Zm-533.6-24.78H250v-5.64a47.31,47.31,0,0,1,3.42-17.75l3.94,1.58a43.27,43.27,0,0,0-3.11,16.17Zm526.83-20.25a43.46,43.46,0,0,0-12.19-18l2.81-3.19A48,48,0,0,1,785.08,471Zm-510.84-19-2.69-3.29a47.66,47.66,0,0,1,21.66-10l.75,4.18A43.29,43.29,0,0,0,270.24,453.41Zm479.29-8.75a43.61,43.61,0,0,0-9.35-1H727V439.4h13.14a47.56,47.56,0,0,1,10.26,1.11Zm-45.51-1H681V439.4h23Zm-46.06,0h-23V439.4h23Zm-46.05,0h-23V439.4h23Zm-46,0h-23V439.4h23Zm-46.06,0h-23V439.4h23Zm-46,0h-23V439.4h23Zm-46.05,0h-23V439.4h23Zm-46.06,0h-23V439.4h23Zm-46.05,0h-23V439.4h23Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 85.64,
    y: 176.72,
    width: 594.49,
    height: 458.57,
    rx: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 138.02,
    y: 312.85,
    width: 58.02,
    height: 278.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.95,
    y: 361.82,
    width: 58.02,
    height: 229.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.88,
    y: 404.65,
    width: 58.02,
    height: 186.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 461.81,
    y: 434.85,
    width: 58.02,
    height: 156.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 569.74,
    y: 523.94,
    width: 58.02,
    height: 67.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.97,
    y: 239.94,
    width: 287.83,
    height: 24.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1442.84,416.75c-30,13.9-70,36.26-62.37,76,7.46,39,54.51,32,82,22.64a266.32,266.32,0,0,0,58.1-27.79c11.75-7.53,28.28-20.55,24.27-36.69-3.45-13.86-19.53-17.91-31.89-15.37-17.93,3.68-38.4,14.6-52.44,26.11-12.75,10.45-22.68,26.72-20.18,43.78,2.28,15.6,15.16,26.72,29.49,31.61,17.85,6.1,42.07,4.85,60-.6,10.91-3.31,21-13.19,13.86-25-8.45-14-26-10.6-38.15-4.44-16.42,8.31-35.85,19.17-44,36.59-6.17,13.23-5.19,29.64,6.8,39.22,11.75,9.39,28.7,9.42,42.93,8.34,11.78-.9,31-3.36,32.89-18.22s-16.54-21.79-28.25-17.37c-18.13,6.85-29.49,29.21-35,46.53a105.1,105.1,0,0,0-.07,62.8c.81,2.6,4.91,1.49,4.1-1.13-8.21-26.62-5.36-55.87,8.69-80,6.73-11.59,20-29.91,35.84-24.78,8.46,2.74,14.46,12.75,7,20.29-5.27,5.3-14.15,6.59-21.23,7.35-10.27,1.09-21.3,1.53-31.4-1.06-17.41-4.48-26.07-20.23-19.59-37.42,5.29-14,18.24-22.82,30.57-30.18,11.72-7,35.09-21.63,45.19-4.32,11.3,19.38-25.47,21.44-35.57,22.2-14.83,1.12-30.53.59-43.51-7.58-13.73-8.64-19.87-23.57-14.88-39.22s18.09-26.23,32-33.94c10.89-6,23.66-13,36-15.41,8.66-1.67,19.6-.3,24.76,7.92,6.18,9.84-1.19,20.59-8.32,27.3-20,18.81-50.14,30.69-75.94,38.63-26.88,8.27-71,10-70.59-29.5.33-34.22,34.17-51.13,61-63.56,2.48-1.15.32-4.81-2.14-3.67Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1134.31,617.06c6.88,14.48,13.14,29.17,19.24,43.93l8.91,22.21,8.55,22.35-12.76-3.76,21.42-16.8c7.15-5.59,14.44-11,21.66-16.49l8.72-6.65,4,10.09c2.9,7.26,5.59,14.61,8.4,21.91s5.36,14.7,8,22c2.53,7.42,5.17,14.79,7.55,22.26s4.77,15,6.92,22.51l-6.15,2.52q-5.64-10.37-10.84-20.91c-3.54-7-6.82-14.11-10.21-21.17-3.23-7.13-6.58-14.2-9.72-21.37s-6.34-14.3-9.36-21.51l12.75,3.43c-7.16,5.57-14.24,11.25-21.46,16.74l-21.72,16.41-9.22,7-3.53-10.72-7.5-22.72-7.13-22.85c-4.6-15.29-9-30.63-12.85-46.2Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1739.89,663.89c-3.81,15.57-8.24,30.91-12.85,46.2l-7.12,22.85-7.5,22.72-3.54,10.72-9.21-7L1678,743c-7.22-5.49-14.3-11.17-21.46-16.74l12.75-3.43c-3,7.21-6.25,14.34-9.36,21.51s-6.49,14.25-9.72,21.37c-3.39,7.06-6.67,14.17-10.22,21.17s-7.07,14-10.84,20.91l-6.14-2.52q3.22-11.34,6.92-22.51c2.38-7.47,5-14.84,7.55-22.26s5.26-14.74,8-22,5.5-14.65,8.4-21.91l4-10.09,8.72,6.65c7.22,5.5,14.51,10.9,21.66,16.49l21.42,16.8-12.76,3.76,8.55-22.35,8.91-22.21c6.09-14.76,12.36-29.45,19.24-43.93Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1926.16,871.33a41.89,41.89,0,0,0,41.89,41.89h643A41.88,41.88,0,0,0,2653,871.33v-380H1926.16Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1857,637.64c3.43-30.92,31-57.39,62-59.57s62,20.16,69.75,50.3a40.11,40.11,0,0,1,48.12,55.48c30.9,4.88,51.26,43.17,38,71.51a75,75,0,0,1,93.93,65.51c8.37-29.16,38.16-50.64,68.47-49.38s58.2,25.15,64.12,54.9c92.12-140.09,334-99.55,402.9,55.84l-100,254-593.18,13.51-267.54-304Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1845.84,716.28c21.71-16.21,45.2-31,71.53-37.39s56.05-3.36,77.38,13.35,31.25,48.66,18.34,72.48c18.36-1.64,37.26,8.25,46.37,24.27s8,37.32-2.84,52.26a71.21,71.21,0,0,1,100.23,43.68c26.51-22.24,71.5-16.78,91.92,11.16,44-41.9,111.32-65,167.16-41,32.38,13.93,57.15,41.84,73.92,72.85s26.4,65.29,35.89,99.24L2022,1072.75l-210.79-67.56Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2371.25,581.7c-15-6.24-30.44-7-43.21-3.25a43.58,43.58,0,0,0-73.9,44.84,32,32,0,0,0,11.49,57.88,43.12,43.12,0,0,0-.43,5.83,43.58,43.58,0,0,0,86,10,32,32,0,0,0,45.32-39.55,34.9,34.9,0,0,0,10.36-13.71C2416.15,621.55,2400.19,593.75,2371.25,581.7Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2192.77,558a33.08,33.08,0,0,0-21.76-1.63A21.94,21.94,0,0,0,2133.8,579a16.12,16.12,0,0,0,5.78,29.14,21.94,21.94,0,0,0,43.09,8,16.09,16.09,0,0,0,22.82-19.91,17.65,17.65,0,0,0,5.22-6.91C2215.37,578.11,2207.34,564.11,2192.77,558Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2065.45,545a13.4,13.4,0,0,1-2.78,12.48c-7.8,9.66-21.61,5.36-25.08-5.54-1.36-4.25-2-8.92-.58-13.15C2042,523.8,2062,532.54,2065.45,545Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2195.84,711a8.55,8.55,0,0,1-1.76,7.93c-5,6.13-13.73,3.4-15.93-3.52a13.61,13.61,0,0,1-.37-8.36C2181,697.51,2193.63,703.06,2195.84,711Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2499,592.05a8.53,8.53,0,0,1-1.77,7.93c-5,6.13-13.72,3.4-15.93-3.53a13.57,13.57,0,0,1-.36-8.35C2484.15,578.59,2496.82,584.13,2499,592.05Z",
    transform: "translate(-250 -325.61)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2611.06,915.34h-643a44.06,44.06,0,0,1-44-44V489.17h731V871.33A44.06,44.06,0,0,1,2611.06,915.34ZM1928.29,493.41V871.33a39.81,39.81,0,0,0,39.76,39.77h643a39.81,39.81,0,0,0,39.77-39.77V493.41Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2611.06,327.73h-643a41.9,41.9,0,0,0-41.89,41.89V491.29H2653V369.62A41.89,41.89,0,0,0,2611.06,327.73Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2655.08,493.41H1924V369.62a44.06,44.06,0,0,1,44-44h643a44.06,44.06,0,0,1,44,44Zm-726.79-4.24h722.54V369.62a39.81,39.81,0,0,0-39.77-39.76h-643a39.81,39.81,0,0,0-39.76,39.76Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1774.79,
    cy: 83.9,
    r: 30.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2470.09,436.41h-338.4a26.9,26.9,0,0,1-26.9-26.9h0a26.9,26.9,0,0,1,26.9-26.9h338.4a26.9,26.9,0,0,1,26.9,26.9h0A26.9,26.9,0,0,1,2470.09,436.41Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2470.09,438.54H2131.7a29,29,0,1,1,0-58.05h338.39a29,29,0,0,1,0,58.05ZM2131.7,384.73a24.78,24.78,0,1,0,0,49.56h338.39a24.78,24.78,0,0,0,0-49.56Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2448.85,690.07s-61-57.41-122-58.61l44.26,29.91-82.54-15.55,76.56,38.27-89.71,6c48.06,8.52,90.53,30.6,125.59,70.58Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2443.59,716s-25.66-42.93-57.83-49.48l20,23.54-41.92-17.87,36.12,32-48.2-4.61c24.47,10.06,44.41,28.36,58.35,57.55Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2669.26,822.87c-32.62-57.09-12.3-132.64-43.69-152L2563.26,748Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2625.57,670.85l-8.06-.86a30.18,30.18,0,0,0-23.55,7.68l-52.68,47.89,22,22.45Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2577.05,937.06c-62.67-19.87-132.26,15.89-157.81-10.71l62.31-77.15Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2419.24,926.35l-2.54-7.7a30.23,30.23,0,0,1,2.55-24.64L2455,832.43l26.58,16.77Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2483.99 644.25 2461.33 580.64 2417.04 635.49 2483.99 644.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2422.78,785.73c45.72,97.77,129.9,174.19,244.28,175.34l44.27-54.82c-25.2-111.57-117.63-177.78-222.84-201.89Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2238.49 378.75 2214.2 342.94 2132.63 443.94 2172.78 460.12 2238.49 378.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2399,699.31h0a9.21,9.21,0,0,1,13-1.38L2495,765a9.23,9.23,0,0,1,1.39,13h0a9.21,9.21,0,0,1-13,1.38l-83.09-67.1A9.23,9.23,0,0,1,2399,699.31Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 2624.55,
    cy: 881.45,
    r: 38.67,
    transform: "translate(1422.9 3155.76) rotate(-88.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 2624.55,
    cy: 881.45,
    r: 23.63,
    transform: "translate(-328.57 -42.82) rotate(-6.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2634.23,882.35a4.32,4.32,0,1,1,6.08-.64A4.32,4.32,0,0,1,2634.23,882.35Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1628,1102.7l-147.6-9-192.59,50.88A216.92,216.92,0,0,0,1140.55,1277l-120.33,315.13,236.46-209.53,65.13,329.9,441.76-1.42-1.42-458Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1510.25,1273.71c-26.75,0-51.73-10.41-68.25-28.82l3.16-2.84c17.68,19.7,45.63,29.81,74.73,27,31.19-3,58.44-20.47,74.78-47.86l3.65,2.18c-17,28.56-45.47,46.75-78,49.91C1516.93,1273.55,1513.57,1273.71,1510.25,1273.71Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1528.62,1216.07c-28.29,13.68-63,.17-77.27-30.07l-4.8-10.24-48.68-103.43L1368.1,1009,1512,939.46l62.65,133.12C1600.36,1127.34,1579.84,1191.31,1528.62,1216.07Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1525.69,1045.61c-12.66,61.68-44.31,103.94-79.14,130.15l-48.68-103.43Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1542.56,968.43c0,74.49-42,125.54-95.26,151.86-54.82,27.09-112.06-77-139.4-146.55-28.38-72.21,49.74-126.36,115.15-126.36S1542.56,894,1542.56,968.43Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1545.52,926c-6.37-76.46-21.91-148.74-92.74-130.26-26.9-37.52-139.46-36.82-167.07,52.38-17.81,57.55-75,85.66-75,85.66,68.67,36.11,132,22.59,220.17-44.6C1458.45,929.5,1537,932.33,1537,932.33Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1533.33,
    cy: 957.55,
    rx: 44.07,
    ry: 34.45,
    transform: "translate(138.47 2030.98) rotate(-82.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1540.2,939.31c-4.57,3.77-6.07,8.88-6,14.34a30,30,0,0,0,1.25,8.07,19.93,19.93,0,0,0,3.83,7.24l-1.26,2.15c-3.5-1.15-6.11-4.09-7.72-7.21a22.16,22.16,0,0,1-2.44-10.23,19.6,19.6,0,0,1,2.8-10.34,13.6,13.6,0,0,1,8.53-6.29Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1420.78,
    cy: 985.41,
    rx: 10.74,
    ry: 12.04,
    transform: "translate(-312.1 -229.43) rotate(-3.79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1364.43,
    cy: 1006.96,
    rx: 9.74,
    ry: 10.92,
    transform: "translate(-521.4 234.46) rotate(-21.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1449.9,954.34c.22,3.37-17.67,2.29-25.35,3.91-6.57,1.38-16.56,7.78-21.06,1.4-4.07-5.76,6.14-12.29,18.79-13.13S1449.67,951,1449.9,954.34Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1334.61,991.36c2,2.76,11.14-6.73,16.39-9.17,4.48-2.08,14-1.87,12.44-9.07-1.41-6.49-11.15-6.7-18.63-1.25S1332.6,988.6,1334.61,991.36Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1406.22,1067.16c4.1-4.93,9.94-8.12,15.87-10.12a47.42,47.42,0,0,1,18.35-2.36l.46,2.44c-5.64,2.68-11.35,4.17-16.85,6s-10.76,3.76-16.33,6.08Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1390.12,1013.81a26.06,26.06,0,0,1-2.76,14,24.83,24.83,0,0,1-4.48,6c-1.65,1.69-3.33,3.1-3.72,4.11a3.44,3.44,0,0,0-.24,1.68c0,.46.1.49.07.56s.19.27.31.47a12.66,12.66,0,0,0,4.53,2.49,123.72,123.72,0,0,0,12.54,3.32l-.06,2.49a39.76,39.76,0,0,1-14-.44,16.1,16.1,0,0,1-7.38-3.47,8.68,8.68,0,0,1-1.61-2.26,7.58,7.58,0,0,1-.66-2.69,8.92,8.92,0,0,1,.8-4.87c1.65-3,3.72-4.38,5.24-5.81a25.47,25.47,0,0,0,4-4.37c2.3-3.19,3.74-7.21,4.93-11.48Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1478.85,
    cy: 1002.76,
    r: 27.17,
    transform: "translate(208.06 2143.61) rotate(-89.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1874.08,1256.59a268.46,268.46,0,0,0-226.15-152.66L1628,1102.7l146.93,334.58,160.83-59.7Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1360.75,1038.53c-1.59-24.43,2.66-81.77-12.21-75.4s-18.59,89.19-18.59,89.19-2.12-138-18-131.67-15.93,106.19-51,212.38l-196.81,415.64c-23.67,50,6.15,108.91,60.46,119.42h0a84.71,84.71,0,0,0,94.69-51.56c51-126.66,144.6-400,153.69-453.23,7.44-43.54,5.52-62.37,2.64-73.56C1370.86,1071.24,1362,1057.58,1360.75,1038.53Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1262.17,1123.84c6-16.37,10-33.49,13.62-50.59s6.65-34.38,9.77-51.63l9.23-51.8c1.63-8.63,3.31-17.26,5.33-25.85,1-4.3,2.11-8.58,3.47-12.85a60.51,60.51,0,0,1,2.42-6.37,21.91,21.91,0,0,1,1.76-3.18,6.75,6.75,0,0,1,3.66-2.92l-.16,0a10.93,10.93,0,0,1,1.9-.2,8.53,8.53,0,0,1,1.74.54,7.52,7.52,0,0,1,2.22,1.89,16.86,16.86,0,0,1,2.44,4.14,54.89,54.89,0,0,1,2.83,8.36,171.56,171.56,0,0,1,3.44,16.87c1.77,11.27,3,22.59,3.93,33.92,1.84,22.67,2.82,45.38,2.6,68.14l-4.83-.1c.53-12.85,1.49-25.61,3-38.37s3.33-25.51,7.34-38a45.78,45.78,0,0,1,4.15-9.18,15.64,15.64,0,0,1,3.68-4.14,8.1,8.1,0,0,1,6.1-1.61,15.16,15.16,0,0,1,1.49.47,4,4,0,0,1,1.56.78,8.54,8.54,0,0,1,.84.74,4.08,4.08,0,0,1,.46.68,8.14,8.14,0,0,1,.75,1.32,29.85,29.85,0,0,1,1.65,4.91,91.48,91.48,0,0,1,1.78,9.64,280.88,280.88,0,0,1,2,38.52c0,6.47-.45,12.75.11,19a105.24,105.24,0,0,0,3.25,18.51,188.79,188.79,0,0,0,5.93,18,113.66,113.66,0,0,1,5.89,18.45,127.46,127.46,0,0,1,1.86,38.56,223.1,223.1,0,0,1-7,37.81l-1.84-.48a222.92,222.92,0,0,0,6.27-37.54,125.18,125.18,0,0,0-2.5-37.62,117.28,117.28,0,0,0-5.91-17.94,189.35,189.35,0,0,1-6.15-18.32,109.48,109.48,0,0,1-3.49-19.14c-.62-6.51-.24-13-.25-19.31a276.92,276.92,0,0,0-2.19-37.92,84.89,84.89,0,0,0-1.75-9.17,26.22,26.22,0,0,0-1.4-4.15,6.25,6.25,0,0,0-.43-.75c-.16-.34-.27-.36-.27-.36s-.34-.16-.56-.25-.52-.2-.78-.27c-1.88-.3-3.92,1.36-5.44,3.88a42.39,42.39,0,0,0-3.65,8.27c-3.73,11.87-5.46,24.56-6.9,37.14s-2.24,25.35-2.68,38l-4.83-.11c.21-22.56-.53-45.19-2.26-67.71-.87-11.26-2-22.5-3.7-33.63a163.25,163.25,0,0,0-3.25-16.45,52.37,52.37,0,0,0-2.55-7.74,13.14,13.14,0,0,0-1.82-3.18,3.65,3.65,0,0,0-.93-.88c-.11,0-.19-.07-.28-.11s-.12.06-.22,0l-.15,0a3.71,3.71,0,0,0-1.26,1.26,17.22,17.22,0,0,0-1.42,2.56,53.82,53.82,0,0,0-2.27,5.9c-1.33,4.08-2.43,8.29-3.46,12.52-2,8.47-3.77,17.05-5.44,25.64l-9.53,51.72c-3.14,17.26-6.58,34.48-10.47,51.6s-8.21,34.21-14.59,50.68Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2012.68,1611.06c-.73,48.93-22,83.13-48.77,102.84l-54.24-.85-13.42-.21h-.3l-63.76-145.15-.12-.34-57.13-130.06,160.81-59.72,60,147.31C2008.09,1557.46,2013.06,1586.17,2012.68,1611.06Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1968.16,1552.49,1546,1599.72,1491.07,1582a77.82,77.82,0,0,0-72.51,13.22c-47.9,38.26-125.78,108.78-105.6,114.45,34,9.56,78.37-8.32,118.21-18.33a93.6,93.6,0,0,1,65.45,7.43l27.62,14.15,420.56-.06Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1323,1702.17c11.39-6.66,23-13,34.56-19.24s23.35-12.23,35-18.36a135.86,135.86,0,0,1,18.33-8.35,93.19,93.19,0,0,1,19.81-4.56,101.54,101.54,0,0,1,20.25-.23,91.49,91.49,0,0,1,19.65,4.21l-.65,2.41a106.62,106.62,0,0,0-19.28-2.17,96.19,96.19,0,0,0-19.19,1.29,99.6,99.6,0,0,0-18.49,4.91c-6,2.11-11.6,5.12-17.56,8.11-11.82,5.84-23.53,11.88-35.44,17.54s-23.78,11.35-35.87,16.66Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1329.16,1681.08c7.67-7.26,15.69-14.08,23.87-20.71s16.57-13,25.17-19.14a297,297,0,0,1,26.74-17.08c9.35-4.91,18.87-10.27,30-11.31l.21,2.48a56.27,56.27,0,0,0-14,5.76c-4.59,2.3-9,5.1-13.38,7.85-8.78,5.55-17.35,11.53-25.92,17.48s-17,12.18-25.56,18.23-17,12.32-25.55,18.36Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1831.52,
    y: 1563.46,
    width: 56.65,
    height: 6.37,
    transform: "translate(-287.89 -279.5) rotate(-1.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1752.26,
    y: 1348.78,
    width: 4.25,
    height: 93.28,
    transform: "translate(-685.45 590.53) rotate(-26.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2012.68,1611.06c-.73,48.93-22,83.13-48.77,102.84l-54.24-.85a.41.41,0,0,1,0-.21,82.78,82.78,0,0,1,79.77-105.13A81.19,81.19,0,0,1,2012.68,1611.06Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 848.1,
    y: 1336,
    width: 242.11,
    height: 50.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "930.22 1386.97 545.81 1386.97 435.37 1002.56 819.78 1002.56 930.22 1386.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "544.28 1387.41 433.26 1000.97 552.18 1000.97 552.18 1004.15 437.49 1004.15 547.34 1386.53 544.28 1387.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "889.05 1246.44 818.59 1004.15 641.38 1004.15 641.38 1000.97 820.98 1000.97 892.11 1245.55 889.05 1246.44"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1154.74,
    cy: 390.76,
    r: 31.86,
    transform: "translate(200.96 1060.55) rotate(-73.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 479.37,
    cy: 1151.09,
    r: 41.06,
    transform: "translate(-1001.07 1027.56) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 2240.62,
    cy: 906.18,
    r: 31.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2450.83,1252.65l-.08-4.25a49.36,49.36,0,0,0,15-2.64l1.38,4A53.8,53.8,0,0,1,2450.83,1252.65Zm-16.42-2.22a53.56,53.56,0,0,1-15-7.16l2.41-3.5a49.35,49.35,0,0,0,13.77,6.59Zm47.41-8.39-2.54-3.4a49.78,49.78,0,0,0,10.69-10.9l3.45,2.47A53.57,53.57,0,0,1,2481.82,1242Zm-74.43-10.15a53.62,53.62,0,0,1-8-14.5l4-1.46a49.49,49.49,0,0,0,7.39,13.36Zm93.48-16.49-4-1.3a49.3,49.3,0,0,0,2.35-15.08c0-1.31-.05-2.61-.15-3.88l4.23-.34c.11,1.4.17,2.81.17,4.22A53.65,53.65,0,0,1,2500.87,1215.4Zm-104.69-14.27c0-.69,0-1.4,0-2.1a53.73,53.73,0,0,1,1.95-14.37l4.09,1.13a49.38,49.38,0,0,0-1.79,13.23c0,.64,0,1.29,0,1.94Zm99.31-20.85a49.46,49.46,0,0,0-7.9-13l3.25-2.73a53.34,53.34,0,0,1,8.58,14.17Zm-87-8.38-3.54-2.33a53.76,53.76,0,0,1,11.13-12.28l2.67,3.3A49.53,49.53,0,0,0,2408.48,1171.9Zm67.59-14.7a48.81,48.81,0,0,0-14-6l1.05-4.11a53.05,53.05,0,0,1,15.23,6.56Zm-44.12-4.26-1.54-4a53.44,53.44,0,0,1,16.21-3.52l.24,4.25A48.7,48.7,0,0,0,2432,1152.94Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1736.66,484.21A23.36,23.36,0,1,1,1760,460.85,23.39,23.39,0,0,1,1736.66,484.21Zm0-42.48a19.12,19.12,0,1,0,19.12,19.12A19.14,19.14,0,0,0,1736.66,441.73Z",
    transform: "translate(-250 -325.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 206.71,
    y: 1383.68,
    width: 2092.66,
    height: 6.38
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetB);
export default __webpack_public_path__ + "static/media/asset-b.2238b9c251acf29c6f93079f7c591148.svg";
export { ForwardRef as ReactComponent };